<template>
    <div class="vue-logo-finder">
        <dentaid-logo-vitis v-if="isVitis" ></dentaid-logo-vitis>
        <img v-if="isDentaidXeros" src="/themes/custom/ef2_custom/images/logos/dentaid-xeros-logo.png" alt="Logo Dentaid Xeros">
        <img v-if="isHalita" src="/themes/custom/ef2_custom/images/logos/halita-logo.png" alt="Logo Halita">
        <img v-if="isPerioAid" src="/themes/custom/ef2_custom/images/logos/Perio-Aid.png" alt="Logo Perio.Aid">
        <img v-if="isInterprox" src="/themes/custom/ef2_custom/images/logos/interprox-logo.png" alt="Logo Interprox">
    </div>
</template>

<script>
export default {
    name: "LogoFinder",

    props: {
        url: {
            type: String,
            required: true
        }
    },

    computed: {
        isVitis() {
            return this.url.includes('vitisforlife.nl') || this.url.includes('vitisforlife.be')
        },

        isDentaidXeros() {
            return this.url.includes('dentaidxeros.nl') || this.url.includes('dentaidxeros.be')
        },

        isHalita() {
            return this.url.includes('halita.nl') || this.url.includes('halita.be')
        },

        isPerioAid() {
            return this.url.includes('perioaid.nl') || this.url.includes('perioaid.be')
        },

        isInterprox() {
            return this.url.includes('interprox.nl') || this.url.includes('interprox.be')
        },
    }
}
</script>